<div class="account-card">
  <mat-card class="card-structure">
    <div class="header-structure">
      <div mat-card-avatar class="avatar">
        <img mat-card-image src="../../../assets/images/avatar-person.svg" alt="user photo" />
      </div>
      <div class="title-subtitle">
        <mat-card-title>{{ this.authService.userCode }}</mat-card-title>
        <mat-card-subtitle [matTooltip]="this.authService.user | async">
          <div class="subtitle-item">{{ this.authService.user | async }}</div></mat-card-subtitle
        >
        <mat-card-subtitle [matTooltip]="this.authService.email">
          <div class="subtitle-item">{{ this.authService.email }}</div></mat-card-subtitle
        >
      </div>
    </div>
    <div>
      <mat-divider></mat-divider>
    </div>
    <div class="actions">
      <ng-content></ng-content>
    </div>
  </mat-card>
</div>
